import React from "react";
import { NavDropdown } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router";

import UserIcon from "../Common/UserIcon";

import sitePaths from "../../constants/sitePaths";

function UserNavItem() {
  const auth = useAuth();
  const navigate = useNavigate();

  const onClickDropdownItem = (e, url) => {
    e.preventDefault();
    navigate(url);
  };

  const handleLoggUt = async (e) => {
    e.preventDefault();
    await auth.removeUser();
    await auth.signoutRedirect({ id_token_hint: auth.user?.id_token });
    navigate(sitePaths.login);
  };

  const userIcon = <UserIcon large />;
  return (
    <NavDropdown
      id="meny-bruker-profil"
      className="meny-bruker-profil"
      title={userIcon}
      align="end"
    >
      <NavDropdown.Item
        href={sitePaths.profil}
        onClick={(e) => onClickDropdownItem(e, sitePaths.profil)}
      >
        Profil
      </NavDropdown.Item>
      <NavDropdown.Divider />
      <NavDropdown.Item href="/login" onClick={handleLoggUt}>
        Logg ut
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default UserNavItem;
